import { Divider } from "primereact/divider"
import logoInfo from '../assets/infopositiva_preto.png';
export const InformacaoInfoPositiva = () => {
    return (
        <div>
        <Divider className="automotiva" align="left">
        <div className="flex-score justify-content-between justify-content-center">

          <img
            style={{ width: "200px", position: "relative" }}
            src={logoInfo}
            alt="logo"
          />
        </div>
      </Divider>
      </div>
    )
}